<template>
  <nav
    v-if="items.length"
    class="hub-breadcrumb"
    aria-label="breadcrumb"
  >
    <template v-for="(item, index) in items">
      <router-link
        v-if="item.to && index < items.length - 1"
        :key="`${item.label}-link`"
        class="hub-breadcrumb__link"
        :to="item.to"
      >
        {{ item.label }}
      </router-link>
      <span
        v-else
        :key="`${item.label}-current`"
        class="hub-breadcrumb__current"
        >{{ item.label }}</span
      >
      <span
        v-if="index < items.length - 1"
        :key="`${item.label}-sep`"
        class="hub-breadcrumb__sep"
        >/</span
      >
    </template>
  </nav>
</template>

<script>
export default {
  name: "HubBreadcrumb",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.hub-breadcrumb {
  display: none;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  line-height: 20px;
  color: var(--colors-light-primary-gray2);
}

.hub-breadcrumb__link {
  color: var(--colors-light-primary-gray2);
  text-decoration: none;
}

.hub-breadcrumb__current {
  color: var(--colors-light-primary-navy-blue);
  font-weight: 700;
}

.hub-breadcrumb__sep {
  color: var(--colors-light-primary-gray2);
}

@media screen and (min-width: 1024px) {
  .hub-breadcrumb {
    display: flex;
  }
}
</style>
